import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=d019cefe&"
import script from "./StatusChip.vue?vue&type=script&lang=ts&"
export * from "./StatusChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports